export const OTP_TYPES = {
  SMS: {
    value: 'SMS',
    name: 'SMS'
  },
  WHATSAPP: {
    value: 'WHATSAPP',
    name: 'Whatsapp'
  }
};

export const MK_JEWELLERS_COMPANY_ID = '-LaAArTYr1ZzOsgbS70t';
